import PropTypes from "prop-types";
import React from "react";
import { Button } from "cxa-components";
import { injectIntl, intlShape } from "react-intl";
import messages from "components/messagesDescription";

const HealthDeclarationForm = ({ data, intl }) => {
  const { id, status, form = Array.prototype } = data || Object.prototype;
  const forms = Array.prototype.concat(form).filter(f => f.status !== "Completed");
  const mustShow = data && (status === "Required" || status === "Incomplete") && forms.length;
  if (!mustShow) {
    return null;
  }
  return (
    <article className="card" key={id}>
      <section>
        <p>{intl.formatMessage(messages.completeDeclarationDescription)}</p>
        <Button
          onClick={() => {
            // eslint-disable-next-line security/detect-non-literal-fs-filename
            window.open(`/hdf/${forms[0] && forms[0].id}`, "hdfWindow");
          }}
        >
          {intl.formatMessage(messages.editDescription)}
        </Button>
      </section>
    </article>
  );
};

HealthDeclarationForm.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    form: PropTypes.any, // can be a form or object
  }),
  intl: intlShape.isRequired,
};

export default injectIntl(HealthDeclarationForm);



// WEBPACK FOOTER //
// ./components/dashboard/widgets/HealthDeclarationForm.js